import { FC, SVGAttributes } from "react";

const AnimalIcon: FC<SVGAttributes<SVGSVGElement>> = ({
  stroke = "#000",
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g
      id="animals"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Vector">
        <path
          d="M8.78959 3.02439C8.57713 2.98565 8.35874 2.99313 8.14949 3.04632C7.94023 3.09951 7.74508 3.19713 7.57749 3.33246C7.40991 3.46778 7.27388 3.6376 7.1788 3.83018C7.08371 4.02277 7.03182 4.23354 7.02672 4.44796C6.96712 4.90653 7.07429 5.37116 7.32897 5.75824C7.58366 6.14533 7.96911 6.42944 8.41597 6.55946C8.62843 6.5982 8.84682 6.59072 9.05609 6.53753C9.26532 6.48434 9.46047 6.38672 9.62808 6.25139C9.79569 6.11607 9.93169 5.94625 10.0268 5.75367C10.1218 5.56109 10.1738 5.35031 10.1788 5.13589C10.2385 4.67732 10.1313 4.21269 9.87662 3.8256C9.62193 3.43852 9.23647 3.1544 8.78959 3.02439Z"
          stroke="black"
          strokeWidth="1.8"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M2.5441 7.86694C2.87174 7.57211 3.33509 7.46079 3.7626 7.55488C3.98587 7.60402 4.19949 7.69591 4.3908 7.82764C4.58163 7.95904 4.74285 8.12497 4.86733 8.31476C5.10599 8.67862 5.24086 9.12264 5.22563 9.5598C5.218 9.77927 5.16616 9.99499 5.07318 10.1942C4.9802 10.3935 4.84797 10.5722 4.68429 10.7199C4.35723 11.0149 3.89438 11.1269 3.467 11.0336C3.24301 10.9847 3.02865 10.8928 2.8367 10.7608C2.64547 10.6294 2.48393 10.4631 2.35924 10.273C2.12043 9.90897 1.98564 9.46458 2.00122 9.02715C2.00904 8.80756 2.06111 8.59174 2.15435 8.39247C2.2476 8.19319 2.38013 8.0145 2.5441 7.86694Z"
          stroke="black"
          strokeWidth="1.8"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M15.2142 3.02439C15.4267 2.98565 15.6451 2.99313 15.8544 3.04632C16.0636 3.09951 16.2588 3.19713 16.4264 3.33246C16.5939 3.46778 16.73 3.6376 16.8251 3.83018C16.9201 4.02277 16.9721 4.23354 16.9771 4.44796C17.0367 4.90653 16.9295 5.37116 16.6749 5.75824C16.4202 6.14533 16.0348 6.42944 15.5878 6.55946C15.3754 6.5982 15.157 6.59072 14.9478 6.53753C14.7385 6.48434 14.5433 6.38672 14.3758 6.25139C14.2082 6.11607 14.0722 5.94625 13.9771 5.75367C13.882 5.56109 13.8301 5.35031 13.825 5.13589C13.7654 4.67732 13.8726 4.21269 14.1272 3.8256C14.3819 3.43852 14.7674 3.1544 15.2142 3.02439Z"
          stroke="black"
          strokeWidth="1.8"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M21.4575 7.86753C21.1305 7.57247 20.6675 7.46086 20.2402 7.55479C20.0169 7.6039 19.803 7.69583 19.6116 7.82764C19.4208 7.95904 19.2596 8.12497 19.1351 8.31476C18.8964 8.67862 18.7616 9.12264 18.7768 9.5598C18.7844 9.77927 18.8363 9.99499 18.9293 10.1942C19.0222 10.3935 19.1545 10.5722 19.3181 10.7199C19.6452 11.0149 20.1082 11.1266 20.5354 11.0326C20.7589 10.9835 20.9726 10.8916 21.164 10.7598C21.3548 10.6284 21.5161 10.4624 21.6405 10.2726C21.8792 9.9088 22.0141 9.46478 21.9988 9.02761C21.9912 8.80815 21.9394 8.59243 21.8464 8.39318C21.7535 8.19394 21.6212 8.0152 21.4575 7.86753Z"
          stroke="black"
          strokeWidth="1.8"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M5.65323 18.2987C5.65323 19.0152 5.93985 19.7023 6.45004 20.2088C6.96023 20.7154 7.65219 21 8.37371 21C10.1874 21 10.1874 20.0996 12.001 20.0996C13.8146 20.0996 13.8146 21 15.6283 21C16.3498 21 17.0417 20.7154 17.552 20.2088C18.0621 19.7023 18.3487 19.0152 18.3487 18.2987C18.3487 14.697 14.7215 10.1949 12.001 10.1949C9.28055 10.1949 5.65323 14.697 5.65323 18.2987Z"
          stroke="black"
          strokeWidth="1.8"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
    </g>
  </svg>
);

export { AnimalIcon };
